<template>
  <div class="login-box">
      <h3>后台管理系统</h3>
    <el-form
      ref="loginForm"
      :model="ruleForm"
      status-icon
      :rules="rules"
      label-width="70px"
      class="demo-ruleForm"
    >
      <el-form-item label="账号" prop="userName">
        <el-input
          v-model="ruleForm.userName"
        ></el-input>
      </el-form-item>
       <el-form-item label="密码" prop="password">
        <el-input
          type="password"
          v-model="ruleForm.password"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="btn-sub" type="primary" @click="submitForm"
          >登录</el-button
        >
        </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { reactive,ref } from 'vue';
import {useRouter} from'vue-router'
export default {
    setup(){
      let router = useRouter()
        let ruleForm = reactive({
            userName:'',
            password:'',
        })
        //创建一个动态数据
        //loginForm引用页面元素（ 组件 ）
        let loginForm=ref(null)
      
        let rules= {
          userName: [
            { required: true, message: '请输入账号', trigger: 'change' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'change' }
          ],
        }
        let submitForm = ()=>{
          //loginForm.value ===this.$refs.loginForm
          console.log(loginForm.value)
          loginForm.value.validate((valid) => { 
          if (valid) {
              let data={
                token:12312312312312,
                name:'Tina'
              }
              localStorage.setItem('token',data.token)
              localStorage.setItem('name',data.name)
              router.push('/goodList')
          } else {
            console.log('error submit!!');
            return false;
          }
        });
            // console.log('登录成功了~~')
        }
        return {
            ruleForm,
            rules,
            submitForm,
            loginForm
        }
    }

};
</script>
<style lang="scss" scoped>
.login-box{
    width: 450px;
    height: 250px;
    background: #efefef;
    border-radius: 10px;
    margin: 100px auto;
    padding:20px 20px 20px 0;
    .btn-sub{
        width: 100%;
    }
    h3{
        text-align: center;
    }
}
</style>